"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("../../context");
const DocumentHeader = () => {
    const { selectedTab: { title }, } = (0, context_1.useSearchResultContext)();
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-heading-wrapper", children: (0, jsx_runtime_1.jsx)("h1", { className: "page-heading text-primary block my-3xl sm:my-5xl", children: title }) }));
};
exports.DocumentHeader = DocumentHeader;
